import { joinClassNames, WithClassnames } from '@vertex-protocol/web-common';
import { ROUTES } from 'client/modules/app/consts/routes';
import Link from 'next/link';

export function AppNavLogo({ className }: WithClassnames) {
  return (
    <Link
      href={ROUTES.portfolio.overview}
      className={joinClassNames(
        'cursor-pointer flex items-center gap-x-1.5',
        className,
      )}
    >
      <span
        style={{
          color: 'var(--color-text-primary)',
          fontWeight: 800,
          fontSize: 20,
          lineHeight: 1,
          letterSpacing: 0,
        }}
      >
        ArCa
      </span>
      <span
        className="rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider"
        style={{
          color: 'var(--color-accent)',
          border: '1px solid var(--color-accent)',
        }}
      >
        ALPHA
      </span>
    </Link>
  );
}
